// @ts-nocheck
export const fileFormats = [
  'xlsx',
  'xlsm',
  'xlsb',
  'xls',
  'docx',
  'docm',
  'doc',
  'pdf',
  'mp4',
  'mov',
  'avi',
  'mpg',
  'wmv',
  'ogg',
  'webm',
  'txt',
];

export const imageFormats = ['png', 'jpeg', 'jpg', 'svg'];
